import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import { TRAVEL_HEALTH_NXT_CONSTANTS } from '@flows/configs/travelHealthNxt/constants'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_TravelHealthV1BerlinDirektDe } from '@flows/insurance/schemas'

const tariff_selection = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('tariff_type')]:
        BaseSchema_TravelHealthV1BerlinDirektDe.shape.tariff_type,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_travelHealth:steps.tariff_selection.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('tariff_type'),
        options: TRAVEL_HEALTH_NXT_CONSTANTS.tariffTypeOptions,
      },
    ],
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('tariff_type'),
      valueToStepName: {
        single: 'travel_quote',
        family: 'family_members',
      },
    },
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default tariff_selection
